import { action, observable, makeObservable } from 'mobx';

export interface IReport {
    id?: string;
    name: string;
    summary: string;
    type: string;
    targetId: null | string;
    itemId: null | string;
    format: string;
    targetGroupId: null | string;
    organizationId: null | string;
    isLoaded: boolean;
    typeDisplay?: string;
    createdOn?: string;
    data?: Record<string, unknown>;
    objectCounts?: Record<string, number>;
    scanData?: Record<string, number>;
    fileCount?: number;
    from: string;
    to: string;
    excludedContent: string[];
}

const REPORT_TYPE_MAP: Record<string, string> = {
    executiveThreat: 'Executive Threat',
    threatByThreat: 'Threat Report - By Threat',
    threatByHost: 'Threat Report - By Host',
    hostAsset: 'Asset Report - Hosts',
    applicationAsset: 'Asset Report - Applications',
    export: 'Export',
    logExport: 'Device Log Export'
};

export default class ReportStore {
    report: IReport = {
        name: '',
        summary: '',
        type: '',
        targetId: null,
        itemId: null,
        targetGroupId: null,
        format: 'csv',
        isLoaded: false,
        from: '',
        to: ''
    };

    constructor(report: IReport) {
        makeObservable(this, {
            report: observable,
            update: action
        });

        this.update(report);
    }

    update(report: IReport): void {
        this.report = {
            ...this.report,
            ...report,
            ...report.data,
            isLoaded: true,
            typeDisplay: REPORT_TYPE_MAP[report.type]
        };

        if (!report.objectCounts) {
            if (!report.scanData) {
                return;
            }

            report.objectCounts = {
                accounts: report.scanData.accountCount,
                artifacts: report.scanData.artifactCount,
                autostarts: report.scanData.autostartCount,
                connections: report.scanData.connectionCount,
                drivers: report.scanData.driverCount,
                hosts: report.scanData.hostCount,
                processes: report.scanData.processCount,
                scripts: report.scanData.scriptCount,
                modules: report.scanData.moduleCount,
                memory: report.scanData.memoryCount
            };

            report.fileCount =
                report.objectCounts.artifacts +
                report.objectCounts.autostarts +
                report.objectCounts.drivers +
                report.objectCounts.processes +
                report.objectCounts.modules +
                report.objectCounts.scripts +
                report.objectCounts.memory;
        }
    }
}
